import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {DragulaService} from "ng2-dragula";
import {EcommerceService} from "../../../ecommerce.service";
import {ActivatedRoute} from "@angular/router";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ProductAddHelperService} from "../product-add-helper.service";
import {ProductImagesComponent} from "../components/product-images/product-images.component";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {merge} from "rxjs/internal/observable/merge";

@Component({
    selector: 'db-product-media',
    templateUrl: './product-media.component.html',
    styleUrls: ['./product-media.component.scss'],
    standalone: false
})
export class ProductMediaComponent implements OnInit, OnDestroy {
  public imageUploadError: string;

  @Input() set mediaForm(formGroup: FormGroup) {
    this.mediaFiles = formGroup.get('images').value;
    this.mediaFiles = this._addOrderKeyToObjects(this.mediaFiles);
    this._productAddHelper.images = this.mediaFiles;
    this.imagesForm = formGroup.get('images') as FormArray;
  }

  imagesForm: FormArray;
  mediaFiles = [];
  files = [...this.mediaFiles];
  website = this._activatedRoute.snapshot.parent.parent.data['website'];
  @Input() websiteId: number;
  subscriptionSubject: Subject<void> = new Subject<void>();
  innerUpdate = false;

  constructor(
    private _dragulaService: DragulaService,
    private _activatedRoute: ActivatedRoute,
    private _productAddHelper: ProductAddHelperService,
    private _modalService: DbModalService,
    private _ecommerceService: EcommerceService) {
  }

  ngOnInit() {
    this._listenImagesForm();
  }

  private _listenImagesForm() {
    this.imagesForm.valueChanges
      .pipe(takeUntil(this.subscriptionSubject))
      .subscribe(value => {
        if (this.innerUpdate) {
          this.innerUpdate = false;
          return;
        }
        this.mediaFiles = this._addOrderKeyToObjects(value);
        this.files = [...this.mediaFiles];
      });
  }

  private _addOrderKeyToObjects(arr) {
    return arr.map((obj, index) => ({...obj, order: index}));
  }

  openProductImages() {
    const modal = this._modalService.open(ProductImagesComponent);
    modal.componentInstance.websiteId = this.websiteId;
    modal.componentInstance.mainImage = this.mediaFiles.at(0);
    modal.componentInstance.secondaryImages = this.mediaFiles.slice(1);
    merge(modal.closed, modal.dismissed)
      .subscribe((value: any[]) => {
        this.imagesForm.clear();
        this.imagesForm.markAsDirty();
        this._productAddHelper.images.forEach((image, order) => {
          this.imagesForm.push(this._productAddHelper.createImageControl({src: image.source_url || image.src, id: image.id, }, order));
        });
      });
  }

  ngOnDestroy() {
    this.subscriptionSubject.next();
    this.subscriptionSubject.complete();
  }
}
